<template>
    <div class="modal fade" :id="ref_id" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document" style="width: 100%; max-width: 550px;">
            <div class="modal-content vld-parent">
                <loading :active.sync="isLoadingFIP" :is-full-page="false" color="#0dc07f" />
                <div class="modal-header">
                    <h5 class="modal-title">Order Items</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <template v-if="items">
                            <div class="row pb-2">
                                <div class="col-md-5  textBold500">Name</div>
                                 <div class="col-md-1  textBold500">Qty</div>
                                <div class="col-md-3  textBold500">Profit</div>
                                <div class="col-md-3 textBold500">Status</div>
                            </div>
                            <div v-for="(item, index) in items" :key="index" class="row pb-2">
                                <div class="col-md-5 ">{{ item.product_name }}</div>
                                <div class="col-md-1 ">{{item.qty}}</div>
                                <div class="col-md-3 ">{{getProfitVal(item)|toCurrency}}</div>
                                <div class="col-md-3">{{ item.status }}<small class="d-block">{{ item.status_date }}</small> </div>
                            </div>
                        </template>
                        <p v-else>NO item found in this order.</p>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
  import Loading from 'vue-loading-overlay';
      import {
        mapGetters
    } from "vuex";
  export default {
      props: ['profit_items', 'ref_id'],
      name: "profitItemsPop",
      components: {
          Loading,
      },
      watch: {
          profit_items(n) {
              this.items = n
          }
      },
      data() {
          return {
              isLoadingFIP: true,
              items: '',
          }
      },
      updated() {
          this.isLoadingFIP = false
      },
    computed: {
        ...mapGetters("auth", ["user"]),
    },
    methods: {
        getProfitVal(item) {
            let profit = 0
            let user =this.user
            if (user && user.type) {
                if (user.type == 'Vendor') {
                    profit = item.final_price * item.qty
                } else if (user.type == 'Contractor') {
                    profit = item.contractor_markup_amt * item.qty
                } else if (user.type == 'Admin') {
                    profit = item.admin_profit_inclusive_tax
                }
            }

 let pp = Math.abs(profit)
if(item.status=="Return Request"||item.status=="Returned"){
  profit=  -Math.abs(pp)
}

            return profit;
        }
    },
  }
</script>
